import React from 'react';

import { AlertFilled, FieldTimeOutlined } from '@ant-design/icons';
import classNames from 'classnames';

import { CoreEnums } from '@/utils/domain/constants';
import { reverseEnumerator } from '@/utils/infrastructure/constants';

import styles from './style.less';

const { TaskImportance } = CoreEnums;

/** Task importance indicator (dots / urgent / critical icons). */
export const taskImportanceIcon = (type) => {
  switch (type) {
    case TaskImportance.Urgent:
      return <FieldTimeOutlined style={{ color: 'var(--ant-warning-color)' }} />;

    case TaskImportance.Critical:
      return <AlertFilled style={{ color: 'var(--ant-error-color)' }} />;

    default: {
      const temp = reverseEnumerator(TaskImportance, { case: 'kebab' });
      const className = temp[type || TaskImportance.None];
      return <span className={classNames(styles.importance, styles[className])} />;
    }
  }
};

export default taskImportanceIcon;
